module.exports = __webpack_public_path__ + "static/media/wheel2vector.5e9cf3c4.svg";